export function getSessionStampFromToken(token?: string): string | null {
    if (!token) return null;

    try {
        const payloadPart = token.split('.')[1];
        if (!payloadPart) return null;

        const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(normalized)) as { session_stamp?: string };
        return payload.session_stamp ?? null;
    } catch {
        return null;
    }
}

export function isSessionSuperseded(token: string | undefined, newSessionStamp: string | undefined): boolean {
    if (!newSessionStamp) return false;

    const currentStamp = getSessionStampFromToken(token);
    if (!currentStamp) return false;

    return currentStamp !== newSessionStamp;
}
